import saasConfig from "./config_saas";


let _config;

if (process.env.NODE_ENV === "development") {
  _config = saasConfig;
} else {
  if (process.env.VUE_APP_PLATFORM === "saas") {
    _config = saasConfig;
  } else {
    _config = saasConfig;
  }
}

export let $config = _config;

export let CONFIG = {
  install(Vue) {
    Vue.prototype.$config = $config;
  },
};
